import { render, staticRenderFns } from "./wechart.vue?vue&type=template&id=dc862612"
import script from "./wechart.vue?vue&type=script&lang=js"
export * from "./wechart.vue?vue&type=script&lang=js"
import style0 from "./wechart.vue?vue&type=style&index=0&id=dc862612&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports